import { render, staticRenderFns } from "./FindRecords.vue?vue&type=template&id=33bd570e&scoped=true"
import script from "./FindRecords.vue?vue&type=script&lang=js"
export * from "./FindRecords.vue?vue&type=script&lang=js"
import style0 from "./FindRecords.vue?vue&type=style&index=0&id=33bd570e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd570e",
  null
  
)

export default component.exports